import { FormEvent, useEffect, useState } from "react"
import { useAppNotificationStore, Form, useProfileStore } from "stores"
import {
  Button,
  H4,
  Input,
  Label,
  P1,
  PasswordInput,
  SelectInput,
  SelectOption,
} from "components"
import { formatDateInput, states } from "utils"
import { useNavigate } from "react-router-dom"

export const PortalPassword: React.FC<{}> = () => {
  const { setDashboardContext } = useAppNotificationStore()
  const { createPortalAccount } = useProfileStore()
  const [form] = useState(new Form<{ portalPassword: string }>())
  const { toast } = useAppNotificationStore()

  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setDashboardContext("Bio-Data")
  }, [setDashboardContext])

  useEffect(() => {
    form.setCredentials({
      portalPassword: "",
    })
  }, [form])

  const handleSubmitBioData = async (e: FormEvent) => {
    e.preventDefault()

    try {
      setIsLoading(true)
      await createPortalAccount(form.credentials).then((resp) => {
        setIsLoading(false)
        if (resp === undefined) return
        if (resp.isSuccessful === true) {
          toast.success(resp.message)
        } else {
          toast.error(resp.message)
          form.setErrors(resp.errors)
        }
      })
    } catch (error: any) {
      setIsLoading(false)
      toast.error(error?.message as string)
    }
  }

  console.log(form.isLoading)

  return (
    <div className="flex flex-col gap-12 items-center">
      <div className="flex flex-col items-center gap-6">
        <H4 className="font-semibold text-accentText">
          Create Portal Password
        </H4>
      </div>
      <form
        onSubmit={handleSubmitBioData}
        className="w-full flex flex-col gap-8"
      >
        <div className="space-y-[5px] w-full">
          <Label
            htmlFor="firstname"
            aria-required
          >
            Password
          </Label>
          <PasswordInput
            id="portalPassword"
            placeholder="Enter your password"
            required
            disabled={isLoading}
            defaultValue={form.credentials?.portalPassword}
            onChange={(e) =>
              form.setCredential("portalPassword", e.target.value)
            }
          />
        </div>

        <div className="flex justify-end items-center mt-2">
          <Button
            type="submit"
            title="Next"
            color="primary"
            className="w-full lg:w-52"
            disabled={isLoading}
            // submitting={form.isLoading === true ? "true" : "true"}
            submitting={isLoading ? "true" : "false"}
          >
            Set Password
          </Button>
        </div>
      </form>
    </div>
  )
}
